const networkIcons = {
  1: require('@images/icons/ethereum-eth-logo.svg'), //ethereum
  56: require('@images/icons/bnb-bnb-logo.svg'), // Binance Smart Chain (BSC)
  97: require('@images/icons/bnb-bnb-logo.svg'), // Binance Smart Chain Testnet (BSC Testnet)
  8453:require('@images/icons/base-logo-in-blue.svg') //base
};

export default function getNetworkIcon(networkId) {
  return networkIcons[networkId] || require('@images/icons/ethereum-eth-logo.svg'); // 默认图标URL
}
